import { FilterStatus } from '@app/modules/shared/components/selection-popover/selection-popover.component';

export class RecentSaleFilterConfig {
  static readonly type = '[Dashboard Filter] RecentSaleFilterConfig';
  constructor(
    public search: string,
    public status: FilterStatus[],
    public date: Date[]
  ) {}
}

export class InProgApplicationFilterConfig {
  static readonly type = '[Dashboard Filter] InProgApplicationFilterConfig';
  constructor(
    public search: string,
    public status: FilterStatus[],
    public date: Date[]
  ) {}
}

export class StaffSearchConfig {
  static readonly type = '[Dashboard Filter] StaffSearchConfig';
  constructor(public search: string, public store: any[]) {}
}

export class PayoutFilterConfig {
  static readonly type = '[Dashboard Filter] PayoutFilterConfig';
  constructor(public store: string[], public date: Date[]) {}
}

export class ResetFilters {
  static readonly type = '[Dashboard Filter] Reset';
  constructor() {}
}
